import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { getUser } from "@utils";
import React from "react";
import { BoxWrapper, Content, ContentTitle } from "../baseItems";
import Base from "./base";

export default class NuveiSTP extends Base {
	getStep1(translate) {
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
			</Content>
		);
	}

	makeExternalPayment() {
		const { stake, selectedCurrency } = this.state;
		let withdrawData = {
			type: "Nuvei",
			method: "STP",
			username: getUser().username,
			amount: {
				value: stake,
				currency: selectedCurrency,
			},
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
